import {AbstractParameter} from 'parameters/AbstractParameter.js';
import {FORWARD} from 'constants/accumulator-modes.js';
import {NONE} from 'constants/aux-event-types.js';

export default superclass => class extends superclass  {
    setupAuxEventParameters() {
        this.createAuxEventType('A');
        this.createAuxEventType('B');
        this.createAuxEventType('C');
        this.createAuxEventType('D');
        this.accumulators = {};
    }

    createAuxEventType(name) {
        let auxEventName = 'auxEvent' + name;
        let auxEventType =  new AbstractParameter(
            auxEventName + 'Type',
            this,
            (o, x) => [],
            {
                defaultValue: NONE,
                automatable: false
            });

        let auxEventVariable =  new AbstractParameter(
            auxEventName + 'Variable',
            this,
            (o, x) => [],
            {
                defaultValue: 'transpose',
                automatable: false
            });

        let auxEventLimit =  new AbstractParameter(
            auxEventName + 'Limit',
            this,
            (o, x) => [],
            {
                defaultValue: 1,
                automatable: false,
                min: 0,
                max: 32
            });

        let auxEventMode =  new AbstractParameter(
            auxEventName + 'Mode',
            this,
            (o, x) => [],
            {
                defaultValue: FORWARD,
                automatable: false
            });

        this[auxEventName + 'TypeParameter'] = auxEventType;
        this[auxEventName + 'LimitParameter'] = auxEventLimit;
        this[auxEventName + 'ModeParameter'] = auxEventMode;
        this[auxEventName + 'VariableParameter'] = auxEventVariable;
        this.registerParameter(auxEventType);
        this.registerParameter(auxEventLimit);
        this.registerParameter(auxEventMode);
        this.registerParameter(auxEventVariable);
    }

    get auxEventAType() {
        return this.auxEventATypeParameter.get();
    }

    get auxEventBType() {
        return this.auxEventBTypeParameter.get();
    }

    get auxEventCType() {
        return this.auxEventCTypeParameter.get();
    }

    get auxEventDType() {
        return this.auxEventDTypeParameter.get();
    }

    getAuxLimit(auxEventType) {
        // Aux Event A => auxEventALimit
        let name = auxEventType.split(' ')[2];
        return this['auxEvent' + name + 'LimitParameter'].get();
    }

    getAuxVariable(auxEventType) {
        // Aux Event A => auxEventALimit
        let name = auxEventType.split(' ')[2];
        return this['auxEvent' + name + 'VariableParameter'].get();
    }

    getAuxMode(auxEventType) {
        // Aux Event A => auxEventALimit
        let name = auxEventType.split(' ')[2];
        return this['auxEvent' + name + 'ModeParameter'].get();
    }

    getAuxJson() {
        let auxes = ['A', 'B', 'C', 'D'];
        let json = {};
        for (let aux of auxes) {
            let typeName = 'auxEvent' + aux + 'TypeParameter';
            let variableName = 'auxEvent' + aux + 'VariableParameter';
            let limitName = 'auxEvent' + aux + 'LimitParameter';
            let modeName = 'auxEvent' + aux + 'ModeParameter';
            json[typeName]= this[typeName].getJson();
            json[variableName]= this[variableName].getJson();
            json[limitName]= this[limitName].getJson();
            json[modeName]= this[modeName].getJson();
        }
        return json;
    }

    fromAuxJson(json) {
        let auxes = ['A', 'B', 'C', 'D'];
        for (let aux of auxes) {
            let typeName = 'auxEvent' + aux + 'TypeParameter';
            let variableName = 'auxEvent' + aux + 'VariableParameter';
            let limitName = 'auxEvent' + aux + 'LimitParameter';
            let modeName = 'auxEvent' + aux + 'ModeParameter';
            this[typeName].fromJson(json[typeName]);
            this[variableName].fromJson(json[variableName]);
            this[limitName].fromJson(json[limitName]);
            this[modeName].fromJson(json[modeName]);
        }
    }
}
